/**
 * 判断当前是否为移动端设备
 * @returns {boolean} true: 移动端, false: PC端
 */
export const isMobile = () => {
  const ua = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  // 额外增加触摸点判断（可选，增强对 iPad Pro 等平板的识别）
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  return isMobile || isTouchDevice;
};


// WEBPACK FOOTER //
// ./src/utils/utils.js